import React, { useContext, useEffect, useState } from 'react';
import styles from './Breadcrumbs.module.scss';
import { GlobalContext } from '../../../../views/pages/GlobalContext';
import { generateKey } from '../../../../functions';

const Breadcrumbs = (_) => {
  const { context } = useContext(GlobalContext);

  const [breadcrumbsStructure, setBreadcrumbsStructure] = useState([]);

  const BreadcrumbsItem = ({ string }) => {
    return <li className={styles.contentItem}>{string}</li>;
  };

  useEffect(
    (_) => {
      if (!!context?.menuFlatStructure && !!context?.menuCurrentPage) {
        const currentPage = context.menuFlatStructure[context.menuCurrentPage - 1];

        if (!!currentPage) {
          const breadcrumbsArgs = [];

          if (currentPage.slug != '/') {
            breadcrumbsArgs.push('Katalog');

            if (!!currentPage?.categoryName) {
              breadcrumbsArgs.push(currentPage.categoryName);
            }
            breadcrumbsArgs.push(currentPage.name);
          }

          setBreadcrumbsStructure(breadcrumbsArgs);
        }
      }
    },
    [context.menuCurrentPage]
  );

  return (
    <ul className={`${styles.contentList} ${!!breadcrumbsStructure?.length ? '' : styles.hideList}`}>
      {!!breadcrumbsStructure && breadcrumbsStructure.map((name) => <BreadcrumbsItem string={name} key={generateKey()} />)}
    </ul>
  );
};

export default Breadcrumbs;
